import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";

import {
  SectionFooterProps,
  SectionNavigationButtonProps,
} from "@/features/survey/form/types";
import BaseButton from "@/components_v2/Button/BaseButton";
import {
  BUTTON_TYPES,
  BUTTON_VARIANTS,
} from "@/components_v2/Button/constants";

const SectionNavigationButton = ({
  section,
  direction = "next",
}: SectionNavigationButtonProps) => {
  const location = useLocation();

  const targetSection =
    direction === "previous" ? section.previousSection : section.nextSection;

  if (!targetSection) return null;

  const navigationUrl = `/reports/${section.survey}/section/${targetSection.id}${location.search}`;

  const isPrevious = direction === "previous";

  return (
    <BaseButton
      variant={BUTTON_VARIANTS.SECONDARY}
      to={navigationUrl}
      type={BUTTON_TYPES.LINK}
      leadingIcon={isPrevious ? <ArrowLeftOutlined /> : undefined}
      trailingIcon={!isPrevious ? <ArrowRightOutlined /> : undefined}
    >
      {targetSection.title}
    </BaseButton>
  );
};

const SectionFooter = ({ section }: SectionFooterProps) => {
  return (
    <div
      className={`section-content-navigation flex justify-between ${!section.previousSection && section.nextSection ? "next-only" : ""}`}
    >
      {section.previousSection && (
        <SectionNavigationButton section={section} direction="previous" />
      )}
      {section.nextSection && (
        <SectionNavigationButton section={section} direction="next" />
      )}
    </div>
  );
};

export default SectionFooter;
